import { api } from '@/config/api';

export interface CopilotMessage {
  role: 'user' | 'assistant';
  content: string;
}

/** Where the user is standing — labels and help text only, never values. */
export interface CopilotPageContext {
  route: string;
  title?: string;
  breadcrumb?: string;
  purpose?: string;
  actions?: string[];
  fields: Array<{ label: string; hint?: string }>;
}

export interface CopilotResponse {
  reply: string;
  actions?: Array<{ label: string; href: string }>;
}

export const copilotService = {
  ask: async (messages: CopilotMessage[], page?: CopilotPageContext): Promise<CopilotResponse> =>
    (await api.post('/slighter_crm/copilot/ask', { messages, page })).data,
};
